import moment from "moment";

  export const dateRegex = (data: string) => { 
  return  moment(data).format('DD/MM/YYYY')
  };